module.exports = __webpack_public_path__ + "img/voce-quer-pedalar.ae0521c3.svg";